import React from 'react';
import styled, { keyframes } from 'styled-components';

import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons/faSpinnerThird';
import { Box } from '../Box';
import { Icon } from '../Icon';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export type LoadingSpinnerProps = {
  size?: number;
  color?: string;
};

const AnimationContainer = styled(Box)`
  animation: ${rotate} 1s linear infinite;
`;

/**
 *
 */
export function LoadingSpinner({
  size = 32,
  color = 'text',
}: LoadingSpinnerProps) {
  return (
    <Box
      data-testid="loading-spinner"
      fontSize={size}
      display="inline-flex"
      color={color}
    >
      <AnimationContainer>
        <Icon icon={faSpinnerThird} />
      </AnimationContainer>
    </Box>
  );
}
